import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ImageCroppedComponent } from './image-cropped.component';

@NgModule({
  imports: [CommonModule],
  declarations: [ImageCroppedComponent],
  exports: [ImageCroppedComponent],
})
export class ImageCroppedModule {}
